// src/locales/en/storePickup.js
export const storePickup = {
  // Page
  pageTitle: "Store Pickup Orders",
  pageDescription: "Track orders collected in person through to dispatch",
  searchPlaceholder: "Search by order #, customer name or phone...",
  orderDate: "Order Date",

  // Columns
  orderNumber: "Order #",
  customerName: "Customer",
  phone: "Phone",
  deliveryNotes: "Delivery Notes",
  deliveryNotesPlaceholder: "Add a note...",
  deliveryNotesSaveFailed: "Failed to save delivery notes",

  // Row actions
  viewOrder: "View Order",
  viewPaymentRecords: "View Payment Records",
  paymentRecords: "Payment Records",
  dispatch: "Dispatch",
  dispatchBlockedUnverified: "Dispatch is blocked while any payment record is unverified",

  // Dispatch modal
  dispatchOrder: "Dispatch Order",
  warehouse: "Warehouse",
  selectWarehouse: "Select a warehouse",
  warehouseRequired: "Please select a warehouse",
  dispatchedDate: "Dispatched Date",
  backdateNotAllowed: "You do not have permission to backdate the dispatched date",
  dispatchSuccess: "Order dispatched successfully",
  dispatchFailed: "Failed to dispatch order",

  // Empty / error states
  noOrdersFound: "No Store Pickup orders found",
  noOrdersFoundDescription: "Orders with the Store Pickup payment type will appear here",
  failedToLoad: "Failed to load Store Pickup orders",

  // Open in POS
  deletePayment: "Delete payment",
  confirmDeletePayment: "Delete this unverified payment record?",
  deletePaymentSuccess: "Payment record deleted",
  deletePaymentFailed: "Failed to delete payment record",
  verifiedLocked: "Verified payments cannot be changed",
  openInPos: "Open in POS Terminal",
  selectPosShop: "Select POS Terminal",
  posShop: "POS Terminal",
  open: "Open",
  noPosShop: "You are not assigned to any POS terminal shop",
};
